module.exports = __webpack_public_path__ + "media/images/career_camp/2023/bullet-ec56626ee58c0aca71af616309f2508a.svg";